import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {T2CardComponent} from '../../../trip2-theme/components/t2-card/t2-card.component';

@Component({
  selector: 'app-mobile-app',
  templateUrl: './mobile-app.component.html',
  styleUrls: ['./mobile-app.component.scss']
})
export class MobileAppComponent implements OnInit {

  @ViewChild('modalChngPsswd') private modalChngPsswd: T2CardComponent;
  @Input() datasTem: any;

  constructor() { }

  ngOnInit() {
  }

  onResetPassword() {
    if (this.datasTem.adminuserid !== undefined) {
      this.modalChngPsswd.open();
    } else {
      alert('The Rides has no users in the system...');
    }
  }

  onCloseModal($event) {
    this.modalChngPsswd.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/riders/mobile-app/mobile-app.component.ts